<template>
  <div>
    <SiteHeader/>
    <SiteNavigation/>
    <router-view/>
    <SiteFooter/>
  </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader.vue'
import SiteNavigation from '@/components/SiteNavigation.vue'
import SiteFooter from '@/components/SiteFooter.vue'

export default {
  name: 'app',
  components: {
    SiteHeader,
    SiteNavigation,
    SiteFooter
  }
};
</script>
